import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import shortid from 'shortid'
import moment from 'moment'
import { Colors, TextIcon } from 'advenio-components'
import Island from '../Island/Island'
import { formatDecimalNumber, parseToInt } from '../../utils/Utils'

const ActionButton = styled(TextIcon)`
  margin-left: 16px;
  cursor: pointer;
`
const DeleteButton = ActionButton.extend`
  fill: rgba(255,255,255, .4);
  color: rgba(255,255,255, .4);
  transition: fill .15s ease-in-out, color .15s ease-in-out;

  &:hover {
    fill: white;
    color: white;
  }
`
const ProductItem = styled.li`
  display: flex;
  align-items: center;
  padding: 8px 16px;
  color: ${Colors.gray900};
  font-size: 16px;
  font-weight: bold;
  line-height: 2;

  &:nth-child(odd) {
    background-color: ${Colors.gray400a};
  }
`
const ProductItemIcon = styled.div`
  height: 20px;
  width: 20px;
  margin-right: 6px;
  background-color: #F5A623;
  border-radius: 20px;
  display: inline-block;
  margin-left: 1px;
`

const PoductItemName = styled.div`
  width: 69%;
  display: inline-block;
  font-size: 14px;
`

const ProductItemPrices = styled.div`

`
const ProductItemService = styled.div`
  display:inline-block;
  width:40%;
`
const ProductItemNameService = styled.div`
  width:100%;
`
const ProductItemStudent = styled.div`
  margin-left: 30%;
`

const ProuctItemPrice = styled.div`
  width:27px;
  font-size: 10px;
  margin-right:29px;
  display: inline-block;
  line-height:16px;
  margin-top:-10px;
  @media only screen and (min-width: 1493px) {
    margin-right:35px;
  }
  ${({ monthly, productAm }) => monthly && `
    margin-left:12px;
    margin-right:17px;
  `}
  ${({ inline }) => inline && `
    margin-top:-3px;
    line-height:14px;
  `}
  ${({ line }) => line && `
  margin-top:-1px;
`}
`
const Header = styled.span`
  font-size: 9px;
`
const Icon = styled.img`
  width: 25px;
  height: 15px;
  margin-left: -8px;
  cursor: pointer;
`
const getSubHeading = (isOwnCenter, products, expires_on) => {
  let date_expires = ''
  if (isOwnCenter) {
    return 'Centro Propio ∙ México'
  }

  if (expires_on !== null) {
    date_expires = `∙ Vigencia: ${moment(expires_on).format('YYYY-MM-DD')}`
  }
  return `${products.length} productos ∙ México ${date_expires}`
}
const ContractIsland = ({ contract: {
  id, name, contract_type, products, own_center_fee, deleted_at, expires_on,
}, onDelete, onEdit, onRestore, flawNoContracts, contract, country }) => {
  const currency_symbol = country.currency_symbol
  const tax_pct = Number(country.operating_parameters.tax_pct)
  const isOwnCenter = contract_type === 'Own Center'
  return (
    <Island
      heading={name}
      subHeading={getSubHeading(isOwnCenter, products, expires_on)}
      color={contract_type === 'Own Center' ? Colors.green500 : ''}
      actionButtons={(onDelete || onEdit) && (
        flawNoContracts ?
          [<ActionButton key={shortid.generate()} label="Dar Alta" iconType="checkmark" onClick={onRestore({ contract })} />] :
          [onDelete && (<DeleteButton
            key={shortid.generate()}
            label="Borrar"
            iconType="remove"
            onClick={onDelete({ id, name })}
          />),
          <ActionButton key={shortid.generate()} label="Editar" iconType="edit" onClick={onEdit({ contract })} />]
      )}
    >
      {own_center_fee && !flawNoContracts && <ProductItem>Mensualidad: ${own_center_fee}</ProductItem>}
      {!own_center_fee && !flawNoContracts && products.map(product => (
        <ProductItem key={product.id}>
          <ProductItemService>
            <ProductItemNameService>
              <ProductItemIcon />
              <PoductItemName>
                {product.product_name}
              </PoductItemName>
            </ProductItemNameService>
            <ProductItemNameService>
              <ProductItemStudent>
                <Icon src="/assets/people_icon.svg" alt="students" /> ({product.students_totals})
              </ProductItemStudent>
            </ProductItemNameService>
          </ProductItemService>
          <ProductItemPrices>
            <ProuctItemPrice monthly inline productAm={product.country_product_id === 3 || product.country_product_id === 5 || product.country_product_id >= 17}>Precio Total</ProuctItemPrice>
            <ProuctItemPrice><Header>Mensualidad</Header><br />{currency_symbol}{parseToInt(formatDecimalNumber(product.monthly_total * (tax_pct / 100 + 1)))}</ProuctItemPrice>
            <ProuctItemPrice><Header>Inscripción</Header><br />{currency_symbol}{parseToInt(formatDecimalNumber(product.enrollment_total * (tax_pct / 100 + 1)))}</ProuctItemPrice>
            <ProuctItemPrice><Header>Reinscripción</Header><br />{currency_symbol}{parseToInt(formatDecimalNumber(product.reenrollment_total * (tax_pct / 100 + 1)))}</ProuctItemPrice>
            <ProuctItemPrice><Header>Materiales</Header><br />{currency_symbol}{parseToInt(formatDecimalNumber(product.materials_total * (tax_pct / 100 + 1)))}</ProuctItemPrice>
            <ProuctItemPrice monthly inline productAm={product.country_product_id === 3 || product.country_product_id === 5 || product.country_product_id >= 17}>Tutor Paga</ProuctItemPrice>
            <ProuctItemPrice line >{currency_symbol}{parseToInt(formatDecimalNumber((contract_type === 'Without Support' ? product.monthly_total : (product.monthly_total - product.monthly_support)) * (tax_pct / 100 + 1)))}</ProuctItemPrice>
            <ProuctItemPrice line >{currency_symbol}{parseToInt(formatDecimalNumber((contract_type === 'Without Support' ? product.enrollment_total : (product.enrollment_total - product.enrollment_support)) * (tax_pct / 100 + 1)))}</ProuctItemPrice>
            <ProuctItemPrice line >{currency_symbol}{parseToInt(formatDecimalNumber((contract_type === 'Without Support' ? product.reenrollment_total : (product.reenrollment_total - product.reenrollment_support)) * (tax_pct / 100 + 1)))}</ProuctItemPrice>
            <ProuctItemPrice line >{currency_symbol}{parseToInt(formatDecimalNumber((contract_type === 'Without Support' ? product.materials_total : (product.materials_total - product.materials_support)) * (tax_pct / 100 + 1)))}</ProuctItemPrice>
          </ProductItemPrices>
        </ProductItem>
      ))}
    </Island>
  )
}

ContractIsland.propTypes = {
  contract: PropTypes.object.isRequired,
  onDelete: PropTypes.func,
}

export default ContractIsland



// WEBPACK FOOTER //
// ./src/Components/ContractIsland/ContractIsland.jsx